export enum ButtonVariant {
  Filled = 'FILLED',
  Outlined = 'OUTLINED',
}
